import axios from 'axios';
import { baseUrl } from '../settings';
import authHeader from './auth-header';

const API_URL = baseUrl + '/subscription/';

class SubscriptionService {
  subscribeAPlan(data) {
    var formData = new FormData();
    formData.append("plan_id", data);

    return axios.post(API_URL + 'subscribeAPlan', formData, { headers: 
      authHeader() });
  }

  chargeForAProduct(data) {
    var formData = new FormData();
    formData.append("plan_id", data);

    return axios.post(API_URL + 'chargeForAProduct', formData, { headers: 
      authHeader() });
  }

  isUserSubscribed() {
    return axios.post(API_URL + 'isUserSubscribed', null, { headers: 
      authHeader() });
  }

  getPricingTable() {
    if(authHeader() !== null)
    {
      return axios.post(API_URL + 'user-pricing-table', null, { headers: 
        authHeader()  });
    }else{
      return axios.post(API_URL + 'pricing-table', null);
    }
  }

  getUserBillings() {
    return axios.post(API_URL + 'user-billings', null, { headers: 
      authHeader() });
  }

  getUserLastNextPayments() {
    return axios.post(API_URL + 'user-last-next-payments', null, { headers: 
      authHeader() });
  }

  cancelSubscription() {
    return axios.post(API_URL + 'cancel', null, { headers: 
      authHeader() });
  }
}

export default new SubscriptionService();